import { render, staticRenderFns } from "./FairDetail.vue?vue&type=template&id=3f609c33"
import script from "./FairDetail.vue?vue&type=script&lang=js"
export * from "./FairDetail.vue?vue&type=script&lang=js"
import style0 from "./FairDetail.vue?vue&type=style&index=0&id=3f609c33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports